<template>
	<Component :is="modalComponent" v-if="modalComponent" @close="$modals.close" @success="$modals.replace" />
</template>

<script>
import {defineAsyncComponent} from 'vue'

export default {
	components: {
		ModalChangeSubscriptionPlan: defineAsyncComponent(() =>
			import('shared/components/ModalChangeSubscriptionPlan.vue')
		),
		ModalChangeSubscriptionSeatCount: defineAsyncComponent(() =>
			import('shared/components/ModalChangeSubscriptionSeatCount.vue')
		),
		ModalBugReporterInfo: defineAsyncComponent(() => import('shared/components/ModalBugReporterInfo.vue')),
		ModalProductViewerInfo: defineAsyncComponent(() => import('shared/components/ModalProductViewerInfo.vue')),
		ModalCollectionCreate: defineAsyncComponent(() => import('shared/components/ModalCollectionCreate.vue')),
		ModalCollectionAccessManagement: defineAsyncComponent(() =>
			import('shared/components/ModalCollectionAccessManagement.vue')
		),
		ModalUploadBlocked: defineAsyncComponent(() => import('shared/components/ModalUploadBlocked.vue')),
		ModalAcquisitionNotice: defineAsyncComponent(() => import('shared/components/ModalAcquisitionNotice.vue')),
	},
	computed: {
		modalComponent() {
			switch (this.$route.query.modal) {
				case 'bug-reporter-info':
					return 'ModalBugReporterInfo'
				case 'product-viewer-info':
					return 'ModalProductViewerInfo'
				case 'change-subscription-plan':
					return 'ModalChangeSubscriptionPlan'
				case 'change-subscription-seats':
					return 'ModalChangeSubscriptionSeatCount'
				case 'collection-create':
					return 'ModalCollectionCreate'
				case 'collection-access-management':
					return 'ModalCollectionAccessManagement'
				case 'upload-blocked':
					return 'ModalUploadBlocked'
				case 'acquisition-notice':
					return 'ModalAcquisitionNotice'
				default:
					return null
			}
		},
	},
}
</script>
